import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'SÍ, QUIERO APAGAR MI ANSIEDAD AHORA POR SOLO ARS 9.500',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    window.open('https://nexovitalplus.com/cart/47540268859579:1', '_blank');
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(242, 92, 5, 0)', '0px 0px 20px 5px rgba(242, 92, 5, 0.3)', '0px 0px 0px 0px rgba(242, 92, 5, 0)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`md:w-auto px-8 py-5 bg-[#F25C05] hover:bg-[#d95205] text-[#FFFFFF] font-bold text-center rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 leading-relaxed ${className}`} data-id="element-9">
      {text}
    </motion.button>;
}